var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center pt-5"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('br'),(_vm.description)?_c('span',{staticClass:"description"},[_vm._v(_vm._s(_vm.description)+"\n\t\t"),_c('br')]):_vm._e(),_c('span',{staticClass:"big-number"},[_vm._v(_vm._s(this.bigNumber))])])
}
var staticRenderFns = []

export { render, staticRenderFns }